import { RowSelectionState } from '@tanstack/react-table';
import { Button, Stack } from 'component-library';
import { TFunction } from 'i18next';

import { ExcelState, PanelState } from '../types';
import { DraftPlotsReviewFooter } from './DraftPlotsReviewFooter';

type CoordinatesFooterActionsProps = {
  t: TFunction;
  cancelLabel: string;
  panelState: PanelState;
  rowSelection: RowSelectionState;
  organizationId: string;
  excelState: ExcelState | null;
  isManualFormComplete: boolean;
  isExcelFormComplete: boolean;
  isSavingManual: boolean;
  isSubmittingExcel: boolean;
  canCommit: boolean;
  onBack: () => void;
  onCancel: () => void;
  onAddManualPlot: () => void;
  onSubmitExcel: () => void;
  onCommit: () => void;
  onSaveDraftPlots: () => void;
  onRefetch: () => void;
  onAddToGroup: () => void;
};

export const CoordinatesFooterActions = ({
  t,
  cancelLabel,
  panelState,
  rowSelection,
  organizationId,
  excelState,
  isManualFormComplete,
  isExcelFormComplete,
  isSavingManual,
  isSubmittingExcel,
  canCommit,
  onBack,
  onCancel,
  onAddManualPlot,
  onSubmitExcel,
  onCommit,
  onSaveDraftPlots,
  onRefetch,
  onAddToGroup,
}: CoordinatesFooterActionsProps) => {
  if (panelState === 'review') {
    return (
      <DraftPlotsReviewFooter
        rowSelection={rowSelection}
        organizationId={organizationId}
        canCommit={canCommit}
        cancelLabel={cancelLabel}
        onCancel={onCancel}
        onSaveDraftPlots={onSaveDraftPlots}
        onCommit={onCommit}
        onRefetch={onRefetch}
        onAddToGroup={onAddToGroup}
      />
    );
  }

  const FOOTER_CLASS = 'flex shrink-0 items-center justify-between border-t border-neutral-black-12 px-6 py-4';

  return (
    <div className={FOOTER_CLASS}>
      <Button variant='outline' onClick={onBack}>
        {panelState === 'options' ? cancelLabel : t('global.ui.buttons.back')}
      </Button>
      <Stack direction='row' className='gap-3'>
        {panelState === 'options' && (
          <Button variant='outline' onClick={onCancel}>
            {cancelLabel}
          </Button>
        )}
        {panelState === 'manual' && (
          <>
            {/* onBack intentionally doubles as Cancel here — both navigate to 'options' */}
            <Button type='button' variant='outline' onClick={onBack}>
              {cancelLabel}
            </Button>
            <Button type='button' onClick={onAddManualPlot} disabled={!isManualFormComplete} loading={isSavingManual}>
              {t('global.ui.buttons.addPlot')}
            </Button>
          </>
        )}
        {panelState === 'excel' && excelState && (
          <Button type='button' onClick={onSubmitExcel} disabled={!isExcelFormComplete} loading={isSubmittingExcel}>
            {t('global.ui.buttons.next')}
          </Button>
        )}
      </Stack>
    </div>
  );
};
